/** Wizard state persisted in sessionStorage so refresh / back-nav works. */
const KEY = "hbe:wizard";

export function loadWizard() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveWizard(patch) {
  const next = { ...loadWizard(), ...patch };
  sessionStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function clearWizard() {
  sessionStorage.removeItem(KEY);
}
